import { useEffect, useState } from "react";
import { useParams } from 'react-router-dom';
import { getKeywordById, updateKeyword } from "../../HTTP/keywords";
import { fetchAllIgo, fetchAllRegions } from "../../HTTP/countries";
import { fetchRawThematics } from "../../HTTP/thematics";
import { countries } from "../../global/countriesAndSources";
import useCurrentLanguage from "../../Helper/useCurrentLanguage";

const WORLD_COUNTRY_CODE = "wd";

export default function EditKeyword() {
    const currentLanguage = useCurrentLanguage();
    const isFrenchLanguage = currentLanguage.startsWith("fr");
    const user = JSON.parse(localStorage.getItem("user"));
    if (localStorage.getItem("subscriptions") === null) {
        window.location.href = '/'
    } else {
      if (JSON.parse(localStorage.getItem("subscriptions")).data === null) {
        window.location.href = '/'
      }
    }

    const { id } = useParams();
    const [formData, setFormData] = useState({
        id: id,
        user_id: user.id,
        keyword: '',
        country_code: '',
        thematic: '',
        igo_id: '',
        region_id: ''
    });

    useEffect(() => {
        const fetchKeyword = async () => {
            const resKeyword = await getKeywordById(id);
            setFormData(prevData => ({
                ...prevData,
                ...resKeyword,
                igo_id: resKeyword?.igo_id ?? '',
                region_id: resKeyword?.region_id ?? ''
            }));
        }
        fetchKeyword();
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const payload = {
                ...formData,
                igo_id: formData.igo_id === '' ? null : Number(formData.igo_id),
                thematic_id: selectedThematicId === '' ? null : Number(selectedThematicId),
                region_id: formData.region_id === '' ? null : Number(formData.region_id)
            };
            await updateKeyword(payload);
            alert('Keyword updated successfully');
            window.location.href = '/followed';
        } catch (err) {
            alert("An error occurred while updating the keyword");
        }
    };

    const [thematics, setThematics] = useState([]);
    // Ancien mot-clé sans thematic_id : on retrouve le nœud par son nom
    const selectedThematicId = formData.thematic_id
        ? String(formData.thematic_id)
        : (formData.thematic ? String(thematics.find((t) => t.name === formData.thematic)?.id ?? '') : '');

    const handleThematicChange = (e) => {
        const idValue = e.target.value;
        const node = thematics.find((t) => String(t.id) === String(idValue));
        setFormData(prevData => ({
            ...prevData,
            thematic_id: idValue,
            thematic: node ? node.name : ''
        }));
    };
    const [igos, setIgos] = useState([]);
    const [regions, setRegions] = useState([]);
    const [igoSearch, setIgoSearch] = useState('');

    const selectedIgo = igos.find((igo) => String(igo.id) === String(formData.igo_id));
    const filteredIgos = igos.filter((igo) => {
        const igoName = igo.label || igo.name || '';
        return igoName.toLowerCase().includes(igoSearch.toLowerCase()) || igo.id === selectedIgo?.id;
    });

    const availableCountries = (() => {
        const worldCountry = countries.find((country) => country.code === WORLD_COUNTRY_CODE);
        const igoCountryCodes = selectedIgo?.country_list
            ? selectedIgo.country_list.split(",").map((code) => code.trim()).filter(Boolean)
            : countries.map((country) => country.code).filter((code) => code !== WORLD_COUNTRY_CODE);

        const filteredCountries = countries.filter((country) =>
            country.code !== WORLD_COUNTRY_CODE && igoCountryCodes.includes(country.code)
        );

        return worldCountry ? [worldCountry, ...filteredCountries] : filteredCountries;
    })();

    useEffect(() => {
        const fetchFormOptions = async () => {
            const [resThematics, resIgos, resRegions] = await Promise.all([
                fetchRawThematics(),
                fetchAllIgo(),
                fetchAllRegions()
            ]);

            setThematics(resThematics);
            setIgos(resIgos?.data || []);
            setRegions(Array.isArray(resRegions) ? resRegions : resRegions?.data || []);
        };

        fetchFormOptions();
    }, []);

    useEffect(() => {
        const isSelectedCountryAvailable = availableCountries.some(
            (country) => country.code === formData.country_code
        );

        if (!formData.country_code || isSelectedCountryAvailable) {
            return;
        }

        setFormData((prevData) => ({
            ...prevData,
            country_code: WORLD_COUNTRY_CODE
        }));
    }, [availableCountries, formData.country_code]);

    return (
        <div className="max-w-md mx-auto mt-8 p-6 bg-white rounded-lg shadow-md">
            <h2 className="text-2xl font-bold mb-6 text-center">Formulaire Mot Clé</h2>
            <form onSubmit={handleSubmit}>
                <div className="mb-4">
                    <label htmlFor="keyword" className="block text-gray-700 text-sm font-bold mb-2">
                        Mot Clé
                    </label>
                    <input
                        type="text"
                        id="keyword"
                        name="keyword"
                        value={formData.keyword}
                        onChange={handleChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                </div>
                <div className="mb-4">
                    <label htmlFor="igo_id" className="block text-gray-700 text-sm font-bold mb-2">
                        Forum global (facultatif)
                    </label>
                    <input
                        type="search"
                        id="igo_search"
                        value={igoSearch}
                        onChange={(e) => setIgoSearch(e.target.value)}
                        placeholder="Rechercher un Forum global"
                        className="w-full px-3 py-2 mb-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                    <select
                        id="igo_id"
                        name="igo_id"
                        value={formData.igo_id}
                        onChange={handleChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    >
                        <option value="">Sélectionner un Forum global</option>
                        {filteredIgos.map((igo) => (
                            <option key={igo.id} value={igo.id}>
                                {igo.label || igo.name}
                            </option>
                        ))}
                    </select>
                    {igos.length === 0 && (
                        <div className="text-center text-gray-500">Chargement des Forums Globaux...</div>
                    )}
                </div>
                <div className="mb-4">
                    <label htmlFor="country" className="block text-gray-700 text-sm font-bold mb-2">
                        Pays (facultatif)
                    </label>
                    <select
                        id="country_code"
                        name="country_code"
                        value={formData.country_code}
                        onChange={handleChange}
                        className={`w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${isFrenchLanguage ? "notranslate" : ""}`}
                        translate={isFrenchLanguage ? "no" : undefined}
                    >
                        <option value="" className={isFrenchLanguage ? "notranslate" : ""} translate={isFrenchLanguage ? "no" : undefined}>Sélectionner un pays</option>
                        {availableCountries.map((country) => (
                            <option key={country.code} value={country.code} className={isFrenchLanguage ? "notranslate" : ""} translate={isFrenchLanguage ? "no" : undefined}>{country.name}</option>
                        ))}
                    </select>
                </div>
                <div className="mb-4">
                    <label htmlFor="region_id" className="block text-gray-700 text-sm font-bold mb-2">
                        Région (facultatif)
                    </label>
                    <select
                        id="region_id"
                        name="region_id"
                        value={formData.region_id}
                        onChange={handleChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    >
                        <option value="">Aucune région</option>
                        {regions.map((region) => (
                            <option key={region.id} value={region.id}>{region.name}</option>
                        ))}
                    </select>
                </div>
                <div className="mb-4">
                    <label htmlFor="theme" className="block text-gray-700 text-sm font-bold mb-2">
                        Thématique (facultatif)
                    </label>
                    <select
                        id="thematic"
                        name="thematic_id"
                        value={selectedThematicId}
                        onChange={handleThematicChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    >
                        <option value="">Sélectionner une thématique</option>
                        {Array.isArray(thematics) && thematics.filter(t => (t.is_active !== 0 && t.is_active !== false) || String(t.id) === String(selectedThematicId)).map(thematic => (
                            <option key={thematic.id} value={thematic.id}>{thematic.path || thematic.name}</option>
                        ))}
                    </select>
                    {thematics.length === 0 && (
                        <div className="text-center text-gray-500">Chargement des thématiques...</div>
                    )}
                </div>
                <div className="flex items-center justify-end">
                    <button
                        type="submit"
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                    >
                        Enregistrer
                    </button>
                </div>
            </form>
        </div>
    );
}
